import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from "@material-ui/core";

export type TextFieldProps = MuiTextFieldProps & {
  readOnly?: boolean;
};

const TextField = ({ readOnly, InputProps, ...textFieldProps }: TextFieldProps) => {
  if (!InputProps) {
    InputProps = {};
  }
  if (readOnly !== undefined) {
    InputProps = { ...InputProps, readOnly };
  }
  return (
    <MuiTextField
      variant="filled"
      InputLabelProps={{ shrink: true }}
      InputProps={InputProps}
      {...textFieldProps}
    />
  );
};

export default TextField;
